module.exports = __webpack_public_path__ + "static/media/afscvideo.e6563be.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/afscvideo.mp4
// module id = VRrp
// module chunks = 1